import { render, staticRenderFns } from "./app-top-navigation.vue?vue&type=template&id=04f2add2&scoped=true&"
import script from "./app-top-navigation.vue?vue&type=script&lang=js&"
export * from "./app-top-navigation.vue?vue&type=script&lang=js&"
import style0 from "./app-top-navigation.vue?vue&type=style&index=0&id=04f2add2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f2add2",
  null
  
)

export default component.exports